import { db } from '../../common/config/Firebase';

/**
 * Adds a new employee to Firestore
 * @param {Object} employeeData - Employee data
 * @param {string} employeeData.dni - Employee DNI (will be used as document ID)
 * @param {string} employeeData.name - Employee name
 * @param {string} employeeData.password - Employee password
 * @param {string} employeeData.position - Employee position
 * @returns {Promise<void>}
 */
export const addEmployeeUseCase = async (employeeData) => {
    try {
        const { dni, name, password, position } = employeeData;

        await db.collection('employees').doc(dni).set({
            name,
            password,
            position
        });

        console.log(`Employee added: ${dni}`);
    } catch (error) {
        console.error('Error adding employee:', error);
        throw error;
    }
};
